import { Serialiser } from "hooks/serialisers/types";
import { LabellerDetails } from "src/store/api/generatedApi";

export const labellerDetailsSerialiser: Serialiser<
  LabellerDetails | null,
  unknown
> = {
  format: (value) => (value === null ? "" : JSON.stringify(value)),
  parse: (text) => {
    if (text === "") return { valid: true, value: null };
    try {
      return { valid: true, value: JSON.parse(text) as LabellerDetails };
    } catch {
      return { valid: false };
    }
  },
};
